import { ca } from '@cian/analytics';

import { userProfileClientInfoForAnalyticsSelector } from '../../../selectors/userProfile';

type TClientInfoDetails = NonNullable<ReturnType<typeof userProfileClientInfoForAnalyticsSelector>>;

export function trackShowSubsClientInfo(clientInfoDetails: TClientInfoDetails) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Show',
    label: 'SubsClientInfo',
    page: {
      extra: {
        clientInfoDetails,
      },
    },
  });
}
